/**
 * 文件说明:
 *
 * dva utils
 *
 * ----------------------------------------
 * 创建用户: leo
 */
import {getDvaApp} from 'umi'

export const globalActionsType = {
    logout: 'leoGlobalActions/logout',
    resetState: 'leoGlobalActions/resetState',
}

export function resetState({namespace}) {
    dispatch({
        type: globalActionsType.resetState,
        payload: {
            namespace,
        },
    })
}

export function getDva() {
    return getDvaApp() || {}
}

export function getStore() {
    return getDva()._store
}

export function getState() {
    const store = getStore()
    if (store && typeof store.getState === 'function') {
        return store.getState()
    }
}

export function dispatch(...arg) {
    const store = getStore()
    if (store && typeof store.dispatch === 'function') {
        return store.dispatch(...arg)
    }
}
